import { Component, OnInit } from '@angular/core';
import{ FormBuilder,Validators } from '@angular/forms';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-helpcenter',
  templateUrl: './helpcenter.component.html',
  styleUrls: ['./helpcenter.component.css']
})
export class HelpcenterComponent implements OnInit {

  constructor(private fb:FormBuilder,private service:AppService,private router: Router) { }

  ngOnInit() {
    if(environment.production){
      this.service.sendEvents("Completehelpcenter", "helpcenter", "HelpCenter");

      fbq('track', "CompleteHelpCenter" , {
        content_type: "helpcenter",
        content_title: this.router.url,
      });
    }

    this.service.setTitle('Get answers to for all the questions | propira');
    this.service.setMetaTags({ property: "og:type", content: 'Property' });
    this.service.setMetaTags({ property: "og:title", content: 'Get answers to for all the questions | propira' });
    this.service.setMetaTags({ name: "keywords", content: 'Get answers to for all the questions | propira' });
    this.service.setMetaTags({ name: "description", content: 'Get answers to for all the questions | propira' });
    this.service.setMetaTags({ property: "og:description", content: 'Get answers to for all the questions | propira' }); 
  }

  helpcenter=this.fb.group({ 
    name:['',Validators.required],
    email:['',[Validators.required,Validators.email]],
    phone:['',[Validators.required,Validators.pattern(/^[6-9]\d{9}$/)]],
    subject:['',Validators.required], 
    message:['',Validators.required],
  })
  
  get helpcenterControl(){ return this.helpcenter.controls; }
  
  helpcenterSubmit:boolean=false;
  helpcenterLoader:boolean=false;
  helpcenterErrorMsg:string="";
  helpcenterSuccessMsg:string="";
  helpcenterEnd(){ 
    this.helpcenterErrorMsg="";
    this.helpcenterSuccessMsg="";
    this.helpcenterSubmit=true;
    
    if(this.helpcenter.valid){
      this.helpcenterLoader=true;
      this.service.post('/helpCentreEnd',this.helpcenter.value).subscribe(
        (data:any)=>{
          if(data[0].error=='0'){
             this.helpcenterSuccessMsg=data[0].msg;
             this.helpcenter.reset(); 
             this.helpcenterSubmit=false;
          }else{ 
            this.helpcenterErrorMsg=data[0].msg;
          }
  
          this.helpcenterLoader=false;
        },(error:any)=>{
          this.helpcenterErrorMsg=error.errorDesc;
          this.helpcenterLoader=false;
        }
      )
    }
  }

  numberOnly(event, length = 0, pointAllow = 0) {
    const iKeyCode = (event.which) ? event.which : event.keyCode;
    if ((pointAllow == 1 && (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))) || (pointAllow == 0 && (iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)))) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }

  validateAlpha(evt){
    var keyCode = (evt.which) ? evt.which : evt.keyCode
    if ((keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 123) && keyCode != 10  && keyCode != 32 && keyCode != 8 && keyCode != 9)

    return false;
    return true;
  }

}
